import { Button, StatusMessage } from '@krp/ui-kit'

import { OneCQueryState } from '../../../shared/ui/OneCQueryState'
import type { PricesActions, PricesVm } from '../model/viewModels'

/**
 * Раздел «Цены»: новые цены строк по видам цен ЭТОЙ поставки (справочник её
 * базы). Текущая цена — как прочитана из 1С; набранное уходит одной командой.
 */
export function PricesSection({ vm, actions }: { vm: PricesVm; actions: PricesActions }) {
  return (
    <div className="onec-screen">
      <OneCQueryState query={vm.query} emptyText="Видов цен в этой базе нет" onRetry={actions.reload} />
      {vm.typesNote !== null && <StatusMessage kind="unavailable" title="Виды цен" text={vm.typesNote} />}
      {vm.types.length > 0 && vm.rows.length > 0 && (
        <div className="onec-scroll">
          <table className="onec-table">
            <thead>
              <tr>
                <th>№</th>
                <th>Наименование</th>
                <th data-numeric="true">Закупка</th>
                {vm.types.map((type) => (
                  <th key={type.key} data-numeric="true">
                    {type.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {vm.rows.map((row) => (
                <tr key={row.lineId}>
                  <td>{row.lineNumber}</td>
                  <td>{row.name}</td>
                  <td data-numeric="true">{row.purchasePrice}</td>
                  {row.cells.map((cell, index) => (
                    <td key={cell.key} data-numeric="true">
                      <input
                        className="onec-cell-input"
                        aria-label={`${vm.types[index]?.name ?? 'Цена'}, строка ${row.lineNumber}`}
                        inputMode="decimal"
                        value={cell.typed ?? cell.planned}
                        data-changed={cell.typed !== null}
                        disabled={!vm.editable}
                        onChange={(event) => actions.typed(cell.key, event.target.value)}
                      />
                      <span className="onec-muted">сейчас {cell.current}</span>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {vm.problem !== null && <p className="onec-problem">{vm.problem}</p>}
      {vm.dirty && (
        <div className="onec-actions">
          <Button variant="primary" onClick={actions.save} disabled={vm.problem !== null || !vm.editable}>
            Сохранить цены
          </Button>
          <Button variant="ghost" onClick={actions.discard}>
            Отменить
          </Button>
        </div>
      )}
    </div>
  )
}
